import { Translate } from "@phosphor-icons/react";
import { LANGUAGES, useI18n } from "@/lib/i18n";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function LangSwitcher() {
  const { lang, setLang, t } = useI18n();
  const active = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="lang-switcher-btn"
          className="flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-frosted/50 dark:border-frosted/50 text-xs font-mono text-steel hover:border-strawberry hover:text-strawberry press-scale">
          <Translate size={14} weight="duotone" /> {active.label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem key={l.code} data-testid={`lang-${l.code}`} onClick={() => setLang(l.code)}
            className={`rounded-none cursor-pointer ${l.code === lang ? "text-strawberry font-semibold" : ""}`}>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
